export interface AnnotationClipboardData {
    categoryName: string;
    bbox: {
        width: number;
        height: number;
    };
}

export function isAnnotationClipboardData(
    obj: any
): obj is AnnotationClipboardData {
    if (!obj || typeof obj !== 'object') return false;

    const requiredKeys: (keyof AnnotationClipboardData)[] = [
        'categoryName',
        'bbox',
    ];

    for (const key of requiredKeys) {
        if (!(key in obj)) return false;
    }

    if (
        typeof obj.categoryName !== 'string' ||
        obj.categoryName.trim() === ''
    ) {
        return false;
    }

    const bbox = obj.bbox;

    if (!bbox || typeof bbox !== 'object') {
        return false;
    }

    const bboxKeys: (keyof AnnotationClipboardData['bbox'])[] = [
        'width',
        'height',
    ];

    for (const key of bboxKeys) {
        if (
            !(key in bbox) ||
            typeof bbox[key] !== 'number' ||
            isNaN(bbox[key])
        ) {
            return false;
        }
    }

    return true;
}
